import Client from '../HttpClient';

const list = (groupCode) => {
	return Client.get(`/admin/api/instruction-item/group/${groupCode}`);
};

const listAll = () => {
	return Client.get(`/admin/api/instruction-item/list-all`);
};

const find = (code) => {
	return Client.get(`/admin/api/instruction-item/${code}`);
};

const create = (payload) => {
	return Client.post(`/admin/api/instruction-item`, payload);
};

const createForm = (payload) => {
	return Client.post(
		`/admin/api/instruction-item/form`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/instruction-item/${code}`, payload);
};

const updateForm = (code, payload) => {
	return Client.put(
		`/admin/api/instruction-item/form/${code}`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const remove = (Code) => {
	return Client.del(`/admin/api/instruction-item/${Code}`);
};

export default {
	list,
	listAll,
	find,
	create,
	createForm,
	update,
	updateForm,
	remove,
};
